/* eslint-disable max-len */
import { Set } from 'immutable';

import { isTrue, isTruthy } from '@/utils/bool';

import { SEPARATOR } from '.';

function makeWhitelist(featureFlag) {
  switch (featureFlag) {
    case 'all':
    case 'none': {
      return featureFlag;
    }

    default: {
      return Set((featureFlag || '').split(SEPARATOR.COMMA).filter(isTruthy));
    }
  }
}

export const INFLUENCERS = makeWhitelist(import.meta.env.VELA_INFLUENCERS);

export const AFFILIATES_ENABLED = isTrue(import.meta.env.VELA_FEATURE_FLAG_AFFILIATES);
export const AFFILIATES_USERS = makeWhitelist(import.meta.env.VELA_FEATURE_FLAG_AFFILIATES_USERS);

export const AI_CREDITS_ENABLED = isTrue(import.meta.env.VELA_FEATURE_FLAG_AI_CREDITS);
export const AI_CREDITS_USERS = makeWhitelist(import.meta.env.VELA_FEATURE_FLAG_AI_CREDITS_USERS);

export const AI_PROFILES_ENABLED = isTrue(import.meta.env.VELA_FEATURE_FLAG_AI_PROFILES);
export const AI_PROFILES_USERS = makeWhitelist(import.meta.env.VELA_FEATURE_FLAG_AI_PROFILES_USERS);

export const BULK_EDIT_ALT_TEXT_ENABLED = isTrue(import.meta.env.VELA_FEATURE_FLAG_BULK_EDIT_ALT_TEXT);
export const BULK_EDIT_ALT_TEXT_USERS = makeWhitelist(import.meta.env.VELA_FEATURE_FLAG_BULK_EDIT_ALT_TEXT_USERS);

export const ETSY_PERSONALIZATION_QUESTIONS_ENABLED = isTrue(import.meta.env.VELA_FEATURE_FLAG_ETSY_PERSONALIZATION_QUESTIONS);
export const ETSY_PERSONALIZATION_QUESTIONS_USERS = makeWhitelist(import.meta.env.VELA_FEATURE_FLAG_ETSY_PERSONALIZATION_QUESTIONS_USERS);

export const IMAGE_GROUPING_ENABLED = isTrue(import.meta.env.VELA_FEATURE_FLAG_IMAGE_GROUPING);
export const IMAGE_GROUPING_USERS = makeWhitelist(import.meta.env.VELA_FEATURE_FLAG_IMAGE_GROUPING_USERS);

export const LISTING_PREVIEW_LINK_ENABLED = isTrue(import.meta.env.VELA_FEATURE_FLAG_LISTING_PREVIEW_LINK);
export const LISTING_PREVIEW_LINK_USERS = makeWhitelist(import.meta.env.VELA_FEATURE_FLAG_LISTING_PREVIEW_LINK_USERS);

export const PHOTO_EDITOR_VIDEO_ENABLED = isTrue(import.meta.env.VELA_FEATURE_FLAG_PHOTO_EDITOR_VIDEO);
export const PHOTO_EDITOR_VIDEO_USERS = makeWhitelist(import.meta.env.VELA_FEATURE_FLAG_PHOTO_EDITOR_VIDEO_USERS);

export const PHOTO_SCORING_ENABLED = isTrue(import.meta.env.VELA_FEATURE_FLAG_PHOTO_SCORING);
export const PHOTO_SCORING_USERS = makeWhitelist(import.meta.env.VELA_FEATURE_FLAG_PHOTO_SCORING_USERS);

export const VIDEO_GROUPING_ENABLED = isTrue(import.meta.env.VELA_FEATURE_FLAG_VIDEO_GROUPING);
export const VIDEO_GROUPING_USERS = makeWhitelist(import.meta.env.VELA_FEATURE_FLAG_VIDEO_GROUPING_USERS);

export const VIDEO_STUDIO_ENABLED = isTrue(import.meta.env.VELA_FEATURE_FLAG_VIDEO_STUDIO);
export const VIDEO_STUDIO_USERS = makeWhitelist(import.meta.env.VELA_FEATURE_FLAG_VIDEO_STUDIO_USERS);

export const WEBINAR_BANNER_ENABLED = isTrue(import.meta.env.VELA_FEATURE_FLAG_WEBINAR_BANNER);
export const WEBINAR_BANNER_USERS = makeWhitelist(import.meta.env.VELA_FEATURE_FLAG_WEBINAR_BANNER_USERS);

export const FEATURE_FLAG = {
  AFFILIATES_ENABLED,
  AFFILIATES_USERS,
  AI_CREDITS_ENABLED,
  AI_CREDITS_USERS,
  AI_PROFILES_ENABLED,
  AI_PROFILES_USERS,
  BULK_EDIT_ALT_TEXT_ENABLED,
  BULK_EDIT_ALT_TEXT_USERS,
  ETSY_PERSONALIZATION_QUESTIONS_ENABLED,
  ETSY_PERSONALIZATION_QUESTIONS_USERS,
  IMAGE_GROUPING_ENABLED,
  IMAGE_GROUPING_USERS,
  LISTING_PREVIEW_LINK_ENABLED,
  LISTING_PREVIEW_LINK_USERS,
  PHOTO_EDITOR_VIDEO_ENABLED,
  PHOTO_EDITOR_VIDEO_USERS,
  PHOTO_SCORING_ENABLED,
  PHOTO_SCORING_USERS,
  VIDEO_GROUPING_ENABLED,
  VIDEO_GROUPING_USERS,
  VIDEO_STUDIO_ENABLED,
  VIDEO_STUDIO_USERS,
  WEBINAR_BANNER_ENABLED,
  WEBINAR_BANNER_USERS,
};

export const FEATURE = {
  AFFILIATES: 'affiliates',
  AI_CREDITS: 'ai-credits',
  AI_PROFILES: 'ai-profiles',
  BULK_EDIT_ALT_TEXT: 'bulk-edit-alt-text',
  ETSY_PERSONALIZATION_QUESTIONS: 'etsy-personalization-questions',
  IMAGE_GROUPING: 'image-grouping',
  LISTING_PREVIEW_LINK: 'listing-preview-link',
  PHOTO_EDITOR_VIDEO: 'photo-editor-video',
  PHOTO_SCORING: 'photo-scoring',
  VIDEO_GROUPING: 'video-grouping',
  VIDEO_STUDIO: 'video-studio',
  WEBINAR_BANNER: 'webinar-banner',
};

export const BETA_CHANNELS = Set([]);
